import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();
export const nativePlatform = Capacitor.getPlatform();

let started = false;

// One-time native shell setup: status bar, splash, external-link handling.
export async function initNativeShell() {
  if (!isNative || started) return;
  started = true;

  document.documentElement.classList.add('is-native', `is-${nativePlatform}`);

  const [{ StatusBar, Style }, { SplashScreen }, { Browser }] = await Promise.all([
    import('@capacitor/status-bar'),
    import('@capacitor/splash-screen'),
    import('@capacitor/browser'),
  ]);

  try {
    if (nativePlatform === 'android') {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#0a0a0b' });
    }
    await StatusBar.setStyle({ style: Style.Dark });
  } catch (_) { /* status bar unavailable */ }

  document.addEventListener('click', (e) => {
    const anchor = e.target?.closest?.('a[href]');
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    if (!/^https?:\/\//i.test(href)) return;
    try {
      const url = new URL(href);
      if (url.host === window.location.host) return;
      e.preventDefault();
      Browser.open({ url: href });
    } catch (_) { /* malformed href */ }
  }, true);

  setTimeout(() => { SplashScreen.hide().catch(() => {}); }, 400);
}
